import clsx from 'clsx';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { findLink } from '../../../../../../../../../LinkyLinky';
import { Link } from '../../../../../../../../../Resource/Types';
import { T } from '../../../../../../../../../Translations';
import InviteIcon from '../../../../../../../../Cutesies/InviteIcon';
import InviteParticipantStore from './InviteParticipantModal/Store';

export interface Props {
  inviteParticipantStore: InviteParticipantStore;
  links: ReadonlyArray<Link>;
}

function InviteButton({ inviteParticipantStore, links }: Props) {
  return findLink('invite', links)
    .map(() => (
      <button
        className={clsx(
          'border rounded border-teal-600 w-full text-teal-600 font-medium py-3 text-sm flex',
          'justify-center items-center',
        )}
        data-intercom-target="builder-invite-participants-and-groups-to-collection-button"
        onClick={() => inviteParticipantStore.modalStore.open()}
      >
        <InviteIcon className="mr-1" />
        <T kind="Invite Participants and Groups to Collection" />
      </button>
    ))
    .getOrElse(emptyFragment);
}

export default observer(InviteButton);
